import { render } from "./VolunteerEditPage.vue?vue&type=template&id=17d4519e"
import script from "./VolunteerEditPage.vue?vue&type=script&lang=js"
export * from "./VolunteerEditPage.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/fep.theismailiusa.org/srv/ibsreg-test.theismailiusa.org/github-httpdocs/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__